const getCookieByName = (name) => {
  const regex = new RegExp(`${name}=([^;]+)`)
  const value = regex.exec(document.cookie)
  return value && value.length ? value[1] : null
}

// const isStrongPasswordEnabled =
//   getCookieByName('ENABLE_STRONG_PASSWORD') === 'TRUE'
const isStrongPasswordEnabled = true
const isDOBCaptureEnabled = getCookieByName('ENABLE_DOB_CAPTURE') === 'TRUE'

export {
  isStrongPasswordEnabled,
  isDOBCaptureEnabled,
}
